import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "text-input-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V4.25H18C20.0711 4.25 21.75 5.92893 21.75 8V16C21.75 18.0711 20.0711 19.75 18 19.75H16.75V22C16.75 22.4142 16.4142 22.75 16 22.75C15.5858 22.75 15.25 22.4142 15.25 22V19V5V2C15.25 1.58579 15.5858 1.25 16 1.25ZM16.75 5.75V18.25H18C19.2426 18.25 20.25 17.2426 20.25 16V8C20.25 6.75736 19.2426 5.75 18 5.75H16.75ZM6 5.75C4.75736 5.75 3.75 6.75736 3.75 8V16C3.75 17.2426 4.75736 18.25 6 18.25H13C13.4142 18.25 13.75 18.5858 13.75 19C13.75 19.4142 13.4142 19.75 13 19.75H6C3.92893 19.75 2.25 18.0711 2.25 16V8C2.25 5.92893 3.92893 4.25 6 4.25H13C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41421 13.4142 5.75 13 5.75H6ZM6.25 10C6.25 9.58579 6.58579 9.25 7 9.25H9H11C11.4142 9.25 11.75 9.58579 11.75 10C11.75 10.4142 11.4142 10.75 11 10.75H9.75V14C9.75 14.4142 9.41421 14.75 9 14.75C8.58579 14.75 8.25 14.4142 8.25 14V10.75H7C6.58579 10.75 6.25 10.4142 6.25 10Z"
    }, null, -1)
  ])))
}
export default { render: render }